'use client'

import {Flex} from 'antd'
import styled from 'styled-components'

const Component = styled(Flex)`
  padding-bottom: 15px;
  align-items: center;
  gap: 30px;
`

export const PageTitle = ({children, className}: React.PropsWithChildren & {className?: string}) => {
  return (
    <Component justify="space-between" style={{width: '100%'}} className={className}>
      {children}
    </Component>
  )
}

PageTitle.__UI = {
  Component,
}
